import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '../model/log-container.model';
import { TerminalContextConstants } from '../model/terminal-context-constants';
import * as uuid from 'uuid';

export class LanguageSelectionController extends AbstractStepController {

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === TerminalContextConstants.language) {
            this.onLanguageChange();
        }
    }

    onRegisterToDashboardContext() {

    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.stopInactivityMonitoring();
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private onLanguageChange() {
        this.setupInitialContextValues();
        this.initalizeMonitoring();
        this.wizardComponent.next();
    }


    private setupInitialContextValues() {

    }

    private initalizeMonitoring() {
        const logContainer = new LogContainer();
        this.dashboardContext.setContextValue(TerminalContextConstants.logContainer, logContainer);
        logContainer.addLog('wizard flow started');

        this.dashboardContext.setContextValue(TerminalContextConstants.uuid, uuid.v4());
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationStarted, new Date().getTime());
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }
}
